import { useQueryClient } from "@tanstack/react-query";
import { Select, SelectProps } from "antd";
import { useInventoryServiceGetServices, useInventoryServiceGetServicesKey } from "api/queries";

import { ServiceItem } from "api/requests";
import queryString from "qs";
import { useEffect, useState } from "react";

interface ISelectSelectProps {
  isForm?: boolean;
  onChange?: (value: any) => void;
  value?: string | number | null;
  items?: ServiceItem[];
  selectProps?: Partial<SelectProps>;
}

const ServiceSelectWithForm: React.FC<ISelectSelectProps> = ({
  isForm,
  onChange,
  value,
  items,
  selectProps,
}) => {
  const [filters, setFilters] = useState("");

  const queryClient = useQueryClient();

  const { data, isLoading, isRefetching, refetch } =
    useInventoryServiceGetServices(
      {
        filters,
        pagination: "",
        sort: "",
      },
      [useInventoryServiceGetServicesKey]
    );

  const handleFilter = (value: string) => {
    setFilters(
      value ? queryString.stringify({ serviceName: { $ilike: `${value}%` } }) : ""
    );
  };

  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: [useInventoryServiceGetServicesKey],
    });
  }, [filters]);

  return (
    <Select
      value={value}
      onChange={(v) => {
        //@ts-ignore
        onChange(v);
      }}
      showSearch
      allowClear
      loading={isLoading || false}
      placeholder="Select a service"
      notFoundContent={false}
      defaultActiveFirstOption={false}
      defaultValue={null}
      filterOption={false}
      {...selectProps}
      onSearch={handleFilter}
      onClear={() => {
        //@ts-ignore
        onChange(null);
        selectProps?.onClear?.();
      }}
      options={
        data?.items?.map((_v) => {
          return {
            label: _v.serviceName,
            value: _v.idService,
            key: _v.idService + "service-id-select-service",
          };
        }) ?? []
      }
    />
  );
};

const ServiceSelectNoForm: React.FC<ISelectSelectProps> = ({
  isForm,
  onChange,
  value,
  items,
  selectProps,
}) => {
  const [filters, setFilters] = useState("");

  const queryClient = useQueryClient();

  const { data, isLoading, isRefetching } = useInventoryServiceGetServices(
    {
      filters,
      pagination: "",
      sort: "",
    },
    [useInventoryServiceGetServicesKey]
  );

  const handleFilter = (value: string) => {
    setFilters(
      value ? queryString.stringify({ serviceName: { $ilike: `${value}%` } }) : ""
    );
  };

  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: [useInventoryServiceGetServicesKey],
    });
  }, [filters]);

  return (
    <Select
      value={value}
      onChange={(v) => {
        const vend = data?.items?.find((i) => i.idService === v);
        //@ts-ignore
        onChange(vend);
      }}
      showSearch
      allowClear
      loading={isLoading || isRefetching}
      placeholder="Search a service"
      notFoundContent={null}
      defaultActiveFirstOption={false}
      defaultValue={null}
      filterOption={false}
      options={
        data?.items?.map((_v) => {
          return {
            label: _v.serviceName,
            value: _v.idService,
            key: _v.idService + "service-id-select-service-no-form",
          };
        }) ?? []
      }
      onSearch={handleFilter}
      {...selectProps}
    />
  );
};

const ServiceSelect: React.FC<ISelectSelectProps> = ({ isForm, ...rest }) => {
  if (isForm) {
    return <ServiceSelectWithForm {...rest} />;
  }
  return <ServiceSelectNoForm {...rest} />;
};

export default ServiceSelect;
